import {Component} from "@angular/core";

@Component({
    selector: "fui-formation-group-template",
    template: "<ng-content></ng-content>"
})
export class FUIFormationGroupTemplateComponent {
}
